const initialState = {
   data: {},
   interests: [],
};

const athleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ATHLETE_PROFILE':
      return { ...state, data: action.payload };
    
    case 'CLEAR_ATHLETE_PROFILE':
      return { ...state, data: {} };

    // Never carry one account's athlete doc into the next sign-in.
    case 'USER_LOGOUT':
      return initialState;

    case 'FETCH_ALL_INTERESTS':
      return { ...state, interests: action.payload };
    
    default:
      return state;
  }
};

export default athleteReducer;
